import type { IResponse } from '~/api/interface/common'

export interface IOptions {
  auth?: boolean
}

/**
 *
 * @param handle 执行函数
 * @param options 配置
 *        auth：默认为true,需要鉴权
 * @returns
 */
export function useRequestAuth<T extends IResponse>(
  handle: () => Promise<T>,
  options?: IOptions
): Promise<T> {
  const { auth = true } = options ?? {}
  const session = useSession()
  const noLogin =
    typeof session === 'undefined' || Object.keys(session ?? {}).length === 0
  if (noLogin && auth) {
    return Promise.resolve({ data: undefined, code: 0, msg: '' } as T)
  }

  return Promise.resolve(handle())
}
